/**
 * time in millisecond
 */
const _debounce = () => {
  let interval: number

  return (callback: () => void, time = 300) => {
    clearTimeout(interval)
    interval = setTimeout(() => {
      callback()
    }, time)
  }
}

export const debounce = _debounce()
